module.exports = __webpack_public_path__ + "img/Group3.f0e73175.png";